import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { sha256 } from "js-sha256";
import "../../App.css";
import "./Deluser.css";
import axios from "axios";
import Cookies from "js-cookie";
import Popup from "reactjs-popup";
import eyeShowPassword from "../../images/eyeShowPassword.png";
import eyeHidePassword from "../../images/eyeHidePassword.png";

const DelUser = () => {
  const history = useHistory();

  const [cell, setCell] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [passwordInputType, setPasswordInputType] = useState("password");
  const [isResetPasswordDisplayed, setIsResetPasswordDisplayed] =
    useState(false);
  const [isPasswordResetSuccessfully, setIsPasswordResetSuccessfully] =
    useState(null);
  const [isResetErrorDisplayed, setIsResetErrorDisplayed] = useState(false);
  const [errorMessageInResetPassword, setErrorMessageInResetPassword] =
    useState("");
  const [wantsGift, setWantsGift] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [deleteReasonText, setDeleteReasonText] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [verifyMode, setVerifyMode] = useState("password");
  const [emailCode, setEmailCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [codeSentTimestamp, setCodeSentTimestamp] = useState(null);
  const [otpResendTimeLeft, setOtpResendTimeLeft] = useState(0);
  const [otpAmountSent, setOtpAmountSent] = useState(0);

  const MIN_TIME_BETWEEN_OTP_RESENDS = 60 * 1000;
  const MAX_OTP_SENDS_BEFORE_COOLDOWN = 3;
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [inFreezeUse, setInFreezeUse] = useState(false);
  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const onFreezeUse = async (checked) => {
    setInFreezeUse(checked);
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/freezeUse",
        // send 0 even thogh its the oposite from logic, cause react didnt refresh the value
        { toFreeze: checked ? 1 : 0 },
        config,
      );

      if (response.data === true) {
        // history.push("/questionnaires");
        // alertUser("");
        setIsErrorMessageDisplayed(false);
      } else {
        alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
      }
    } catch (error) {
      alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
    }
  };

  const sendCodeToEmail = async () => {
    setIsErrorMessageDisplayed(false);

    if (!email) {
      alertUser("יש להכניס כתובת מייל");
      return;
    }

    const now = Date.now();

    if (
      codeSentTimestamp &&
      now - codeSentTimestamp < MIN_TIME_BETWEEN_OTP_RESENDS
    ) {
      alertUser("הקוד נשלח כבר לפני רגע. אנא המתיני לפני שליחת קוד נוסף");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/otp/send",
        { email },
        config,
      );

      if (response.status === 200) {
        setIsCodeSent(true);
        setOtpAmountSent((prev) => prev + 1);
        setCodeSentTimestamp(Date.now());
      }
    } catch (error) {
      if (error.response?.status === 404) {
        alertUser("המייל לא נמצא במערכת");
      } else if (error.response?.status === 400) {
        alertUser("נשלחו יותר מדי קודים. נא לנסות שוב בעוד כמה דקות");
      } else {
        alertUser("לא הצלחנו לשלוח קוד למייל. נא לנסות שוב");
      }
    }
  };

  const verifyEmailCode = async () => {
    setIsErrorMessageDisplayed(false);

    if (!emailCode) {
      alertUser("יש להכניס את הקוד שנשלח למייל");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/otp/verify",
        {
          email,
          otp: emailCode,
        },
        config,
      );

      if (response.status === 200 && Cookies.get("userId") > "0") {
        setIsVerified(true);
        setInFreezeUse(Cookies.get("activeUser") === "0");
      } else {
        alertUser("הקוד שגוי או שפג תוקף");
      }
    } catch (error) {
      alertUser("הקוד שגוי או שפג תוקף");
    }
  };

  useEffect(() => {
    const updateFunction = () => {
      if (codeSentTimestamp) {
        const timeLeft = Math.max(
          0,
          MIN_TIME_BETWEEN_OTP_RESENDS - (Date.now() - codeSentTimestamp),
        );

        setOtpResendTimeLeft(timeLeft);
      }
    };

    const interval = setInterval(updateFunction, 1000);

    updateFunction();

    return () => clearInterval(interval);
  }, [codeSentTimestamp]);

  // שלב אחרון – מחיקה סופית
  const delUser = async () => {
    if (!isVerified) {
      alertUser("ראשית יש לבצע אימות עם טלפון, סיסמה ומייל.");
      return;
    }

    if (!confirmDelete) {
      alertUser("נא לסמן שמאשרים מחיקה סופית של הכרטיס.");
      return;
    }

    if (!deleteReason) {
      alertUser("נא לבחור סיבה להסרת הכרטיס (אפשר גם לבחור 'אחר').");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PdelUser",
        {
          cell: cell || Cookies.get("userId"),
          reason: deleteReason,
          extraText: deleteReasonText,
        },
        config,
      );

      if (response.data === true) {
        alertUser("הכרטיס שלך הוסר מדאבל. המון בהצלחה בהמשך הדרך 💗");
        history.push("/"); // או לכל מסך אחר שתרצי
      } else {
        alertUser("קרתה תקלה במחיקה. נסי שוב או פני אלינו.");
      }
    } catch (error) {
      console.log(error);
      alertUser("אירעה שגיאה בעת מחיקת המשתמש.");
    } finally {
      setLoading(false);
    }
  };

  const israelPhoneValidatorRegex =
    /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/i;

  const phoneValidator = (phoneNumber) => {
    return israelPhoneValidatorRegex.exec(phoneNumber) !== null;
  };
  const checkPassword = (password) => {
    if (password) {
      return true;
    } else {
      return false;
    }
  };

  const resetUserPassword = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/reset/password",
        { email },
        config,
      );

      // console.log(response.status);
      if (response.status === 200) {
        setIsResetErrorDisplayed(false);
        setIsPasswordResetSuccessfully(true);
        setInterval(() => {
          setIsResetPasswordDisplayed(false);
          setIsPasswordResetSuccessfully(null);
        }, 5000);
      }
    } catch (error) {
      if (error.response.status === 404) {
        setIsResetErrorDisplayed(true);
        setErrorMessageInResetPassword(
          "כתובת האימל לא קיימת במערכת, נסה שנית או צור קשר",
        );
      }
    }
  };

  const resetPasswordClicked = () => {
    // console.log("starting resetting password");
    setIsResetPasswordDisplayed(true);
  };

  const logInClicked = async () => {
    // console.log(sha256(password));
    if (phoneValidator(cell)) {
      if (checkPassword(password)) {
        // console.log("Starting log in process");
        setIsErrorMessageDisplayed(false);
        try {
          const response = await axios.post(
            process.env.REACT_APP_LOCALHOST_ADDRESS + "/PlogIn",
            {
              phone: cell,
              password: sha256(password),
            },
            config,
          );

          if (Cookies.get("userId") > "0" && response.status == 200) {
            setIsVerified(true);
            setInFreezeUse(Cookies.get("activeUser") === "0"); // הפוך לוגית
          } else {
            alertUser(
              "המשתמש לא קיים או שיש טעות בסיסמה, על מנת ליצור משתמש, אנא הירשם." +
                "   יש  מצב אולי שבחרת סיסמה עם אות גדולה והקשת אות קטנה? או להיפך?",
            );
          }
        } catch (error) {
          if (error.message.includes(500)) {
            alertUser("יש שגיאה בשרת, אנא נסה שנית עוד מעט");
          } else {
            alertUser(
              "המשתמש לא קיים או שיש טעות בסיסמה, על מנת ליצור משתמש, אנא הירשם." +
                "   יש  מצב אולי שבחרת סיסמה עם אות גדולה והקשת אות קטנה? או להיפך?",
            );
          }
        }
      } else {
        alertUser("על מנת להתחבר יש להשתמש בסיסמה");
      }
    } else {
      alertUser("מספר הטלפון לא תקין, יש להכניס מספר טלפון ישראלי");
    }
  };

  return (
    <div className="deluser-page">
      <div className="deluser-card">
        <Link to="/questionnaires" style={{ textDecoration: "none" }}>
          <div id="backBtn" className="button whiteBackNBorder">
            {"ביטול "}
            <b>→</b>
          </div>
        </Link>

        <h2 className="pageTitle" style={{ marginTop: "16px" }}>
          מחיקת כרטיס מדאבל
        </h2>

        {/* שלב 1 – אימות משתמש */}
        <form className="deluser-form" onSubmit={(e) => e.preventDefault()}>
          <label>זיהוי משתמש</label>

          <div className="login-tabs">
            <div
              className={`login-tab ${verifyMode === "password" ? "active" : ""}`}
              onClick={() => {
                setVerifyMode("password");
                setIsErrorMessageDisplayed(false);
              }}
            >
              עם סיסמה
            </div>

            <div
              className={`login-tab ${verifyMode === "emailCode" ? "active" : ""}`}
              onClick={() => {
                setVerifyMode("emailCode");
                setIsErrorMessageDisplayed(false);
              }}
            >
              קוד למייל
            </div>
          </div>
          {verifyMode === "password" ? (
            <>
              <input
                type="number"
                id="tel"
                placeholder="טלפון"
                value={cell}
                onChange={(e) => setCell(e.target.value)}
              ></input>
              <div className="password-input-container">
                <span
                  className="password-input-span"
                  onClick={() => {
                    if (passwordInputType === "password") {
                      setPasswordInputType("text");
                    } else {
                      setPasswordInputType("password");
                    }
                  }}
                >
                  {passwordInputType === "text" ? (
                    <img className="eye-image-in-span" src={eyeHidePassword} />
                  ) : (
                    <img className="eye-image-in-span" src={eyeShowPassword} />
                  )}

                  {/* style ={{backgroundImage: `url(${eyeShowPassword})`}} */}
                </span>
                <input
                  type={passwordInputType}
                  id="pwd"
                  placeholder="סיסמה"
                  value={password}
                  className="password-input-field"
                  onChange={(e) => setPassword(e.target.value)}
                />{" "}
              </div>

              <button
                type="button"
                className="button mainButton"
                onClick={logInClicked}
              >
                המשך להסרת הכרטיס
              </button>
            </>
          ) : (
            <>
              <input
                type="email"
                placeholder='דוא"ל'
                value={email}
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
              />

              <div
                className="button whiteBackNBorder"
                onClick={otpResendTimeLeft > 0 ? undefined : sendCodeToEmail}
                style={{
                  opacity: otpResendTimeLeft > 0 ? 0.6 : 1,
                  cursor: otpResendTimeLeft > 0 ? "default" : "pointer",
                }}
              >
                {isCodeSent ? "שלחו לי קוד נוסף" : "שלחו לי קוד למייל"}
              </div>
              {isCodeSent && (
                <>
                  <input
                    type="number"
                    placeholder="הקוד שקיבלת במייל"
                    value={emailCode}
                    onChange={(e) => setEmailCode(e.target.value)}
                  />

                  <button
                    type="button"
                    className="button mainButton"
                    onClick={verifyEmailCode}
                  >
                    המשך להסרת הכרטיס
                  </button>

                  {otpAmountSent >= MAX_OTP_SENDS_BEFORE_COOLDOWN ? (
                    <div className="login-switch-hint">
                      שלחת מספר בקשות קוד בזמן קצר 😊 ניתן לבקש קוד נוסף בעוד 10
                      דקות. בינתיים מומלץ לבדוק בתיקיית הספאם/עדכונים
                    </div>
                  ) : otpResendTimeLeft > 0 ? (
                    <div className="login-switch-hint">
                      ניתן לשלוח קוד נוסף בעוד{" "}
                      {Math.ceil(otpResendTimeLeft / 1000)} שניות
                    </div>
                  ) : (
                    <div
                      className="login-switch-hint"
                      onClick={sendCodeToEmail}
                    >
                      לא קיבלת? שלחו לי שוב
                    </div>
                  )}
                </>
              )}
            </>
          )}

          {isErrorMessageDisplayed && (
            <div className="error-message">
              <h5>{errorMessage} </h5>
            </div>
          )}
        </form>

        {/* אחרי "אימות" – שאר התהליך, בתוך אותו כרטיס */}
        {isVerified && (
          <div className="delete-flow">
            <div className="delete-message">
              <p>היי,</p>
              <p>הסרת הכרטיס היא לצמיתות וללא אפשרות שחזור.</p>
              <p>האם להשהות את הפרופיל או להסיר?</p>
              <p>אם זה בגלל המנוי – אפשר לקבל מנוי ניסיון לחודש מתנה.</p>
              <p>
                נשמח לקבל משוב על השימוש באתר והסיבה להסרת הכרטיס...
                <br />
                ובמידה וההסרה היא מסיבות טובות 🙂 האם הכרתם דרכנו?
              </p>
              <p>בכל אופן, המון בהצלחה בהמשך הדרך!</p>
            </div>

            {/* מנוי מתנה */}
            <div className="form-group gift-row">
              <button
                type="button"
                className={`button gift-btn ${
                  wantsGift ? "secondaryButton" : "mainButton"
                }`}
                onClick={async () => {
                  if (wantsGift) return; // הגנה נוספת

                  if (Cookies.get("userId") <= "0") {
                    alertUser("נא למלא טלפון וסיסמה כדי לקבל מנוי מתנה.");
                    return;
                  }

                  setLoading(true);
                  try {
                    const response = await axios.post(
                      process.env.REACT_APP_LOCALHOST_ADDRESS + "/PvipGift",
                      {
                        cell: cell,
                        mnth: 1,
                        from: 6,
                      },
                      config,
                    );

                    if (response.data === true) {
                      setWantsGift(true); // 🔥 כאן הכפתור יתחלף לאפור ולא יהיה לחיץ
                      alertUser("קיבלת מנוי לחודש מתנה :) בהצלחה!");
                    }
                  } catch (error) {
                    console.log(error);
                  } finally {
                    setLoading(false);
                  }
                }}
                disabled={loading || wantsGift} // ⛔️ לא ניתן ללחוץ שוב
              >
                {wantsGift
                  ? "המתנה ניתנה ✔︎"
                  : loading
                    ? "שולח…"
                    : "אשמח לקבל חודש ניסיון חינם"}
              </button>
            </div>

            <br />

            <div
              className="pause-card"
              style={{
                padding: "10px 14px",
                marginTop: "12px",
                marginBottom: "8px",
                border: "1px solid var(--grey-color)",
                borderRadius: "18px",
                boxShadow: "-moz-initial0 2px 8px rgba(0,0,0,0.04)",
                background: "var(--container-color)",
              }}
            >
              <label
                className="checkbox-row"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  margin: 0,
                }}
              >
                <input
                  type="checkbox"
                  checked={!inFreezeUse}
                  onChange={(e) => onFreezeUse(!e.target.checked)}
                  style={{
                    width: "22px",
                    height: "22px",
                    accentColor: "var(--border-color)",
                  }}
                />

                <span
                  className="status-main-text"
                  style={{
                    fontSize: "17px",
                    fontWeight: "700",
                    whiteSpace: "nowrap",
                  }}
                >
                  סטטוס הפרופיל: {!inFreezeUse ? "פעיל" : "בהשהייה"}
                </span>
              </label>
              <div
                style={{
                  fontSize: "12px",
                  color: "#777",
                  textAlign: "center",
                  marginTop: "4px",
                }}
              >
                כדי לשנות את הסטטוס, לחצו על הסימון
              </div>
            </div>
            <br />
            {/* סיבת מחיקה */}
            <div className="form-group">
              <div className="section-subtitle">* מהי הסיבה להסרת הכרטיס? </div>

              <label className="radio-row">
                <input
                  type="radio"
                  name="delReason"
                  value="2"
                  checked={deleteReason === "2"}
                  onChange={(e) => setDeleteReason(e.target.value)}
                />
                מצאתי זוגיות דרך דאבל 💍
              </label>

              <label className="radio-row">
                <input
                  type="radio"
                  name="delReason"
                  value="3"
                  checked={deleteReason === "3"}
                  onChange={(e) => setDeleteReason(e.target.value)}
                />
                מצאתי זוגיות שלא דרך דאבל
              </label>

              {/* פיצול לשתי אפשרויות נפרדות */}
              <label className="radio-row">
                <input
                  type="radio"
                  name="delReason"
                  value="4"
                  checked={deleteReason === "4"}
                  onChange={(e) => setDeleteReason(e.target.value)}
                />
                <span className="radio-text">
                  <span className="radio-main">לא קיבלתי התאמות מתאימות</span>
                  <span className="radio-hint">
                    (אפשר לעדכן את ההעדפות ב{" "}
                    <Link
                      to="/aboutpartner"
                      onClick={(e) => e.stopPropagation()} // שלא ילחץ על הרדיו
                    >
                      מי יכול להתאים לי
                    </Link>
                    )
                  </span>
                </span>
              </label>

              <label className="radio-row">
                <input
                  type="radio"
                  name="delReason"
                  value="5"
                  checked={deleteReason === "5"}
                  onChange={(e) => setDeleteReason(e.target.value)}
                />
                <span className="radio-text">
                  <span className="radio-main">מעט מדי התאמות/תגובות</span>
                  <span className="radio-hint">
                    (אפשר לעדכן את ההעדפות ב{" "}
                    <Link
                      to="/aboutpartner"
                      onClick={(e) => e.stopPropagation()}
                    >
                      מי יכול להתאים לי
                    </Link>
                    )
                  </span>
                </span>
              </label>

              <label className="radio-row">
                <input
                  type="radio"
                  name="delReason"
                  value="6"
                  checked={deleteReason === "6"}
                  onChange={(e) => setDeleteReason(e.target.value)}
                />
                לא מחפש/ת כרגע
              </label>

              <label className="radio-row">
                <input
                  type="radio"
                  name="delReason"
                  value="7"
                  checked={deleteReason === "7"}
                  onChange={(e) => setDeleteReason(e.target.value)}
                />
                אחר (נא לפרט)
              </label>

              <textarea
                className="freetext"
                value={deleteReasonText}
                onChange={(e) => setDeleteReasonText(e.target.value)}
                placeholder="רוצה להוסיף הערה או בקשה? (לא חובה, אבל מאוד עוזר לנו להשתפר 🙂)"
              />
            </div>

            {/* אישור מחיקה סופית */}
            <div className="form-group checkbox-row">
              <label>
                <input
                  type="checkbox"
                  checked={confirmDelete}
                  onChange={(e) => setConfirmDelete(e.target.checked)}
                />
                אני מאשר/ת מחיקה סופית של הכרטיס שלי מדאבל
              </label>
            </div>

            <button
              className="button mainButton"
              onClick={delUser}
              disabled={loading}
            >
              {loading ? "מבצע מחיקה..." : "מחיקה סופית"}
            </button>
            {isErrorMessageDisplayed && (
              <div className="error-message">
                <h5>{errorMessage} </h5>
              </div>
            )}
          </div>
        )}
      </div>
      <Popup
        open={isResetPasswordDisplayed}
        contentStyle={{ minWidth: "80%", borderRadius: "5px" }}
        position="right center"
        onClose={() => setIsResetPasswordDisplayed(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        <div className="reset-password-container">
          {isPasswordResetSuccessfully == true ? (
            <h4>סיסמה חדשה נשלחה למייל שלך, יתכן לתיקיית הספאם</h4>
          ) : (
            <>
              <div className="reset-password-title">איפוס סיסמה</div>
              <div className="reset-password-body">
                סיסמה חדשה תשלח לך למייל, יתכן לתיקיית הספאם
              </div>
              <input
                className="reset-password-email-input"
                type="email"
                id="email"
                value={email}
                autocomplete="off"
                placeholder='דוא"ל'
                onChange={(e) => {
                  setIsResetErrorDisplayed(false);
                  setEmail(e.target.value);
                }}
              ></input>
              <div
                className="reset-password-popup-button"
                onClick={resetUserPassword}
              >
                שלח לי סיסמה
              </div>
              {isResetErrorDisplayed ? (
                <h4>{errorMessageInResetPassword}</h4>
              ) : null}
            </>
          )}
        </div>
      </Popup>
    </div>
  );
};

export default DelUser;
